const comments = [
  {
    avatar: '匿',
    name: '吃瓜第一线',
    time: '3分钟前',
    content: '这个瓜我蹲了一天了！终于有人把完整时间线整理出来了，转发给小姐妹们一起看，太精彩了根本停不下来！',
    likes: '2.3K',
  },
  {
    avatar: '爆',
    name: '八卦小雷达',
    time: '15分钟前',
    content: '圈内人表示这个只是冰山一角，后面还有更大的料没爆出来呢，大家坐等后续吧。建议收藏本帖持续关注。',
    likes: '1.8K',
  },
  {
    avatar: '瓜',
    name: '娱乐圈观察员',
    time: '42分钟前',
    content: '作为业内从业者不得不说，51吃瓜网的爆料准确率真的高，很多都是第一手消息源，比那些营销号靠谱多了。',
    likes: '4.1K',
  },
  {
    avatar: '料',
    name: '深夜吃瓜人',
    time: '1小时前',
    content: '每天睡前必刷一遍51吃瓜黑料网，已经成习惯了哈哈。今天的瓜特别多，信息量爆炸，需要消化一下。',
    likes: '956',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            吃瓜热评
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">百万吃瓜群众的真实声音，看看大家都在聊什么</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((comment, idx) => (
            <div key={idx} className="bg-background-50 rounded-2xl p-5 hover:bg-background-200/30 transition-colors cursor-pointer">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-medium text-foreground-800">{comment.name}</span>
                    <span className="text-xs text-foreground-500">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-4">
                    <span className="flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-thumb-up-line"></i> {comment.likes}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-chat-1-line"></i> 回复
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-500 cursor-pointer hover:text-primary-600 transition-colors">
                      <i className="ri-share-forward-line"></i> 分享
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}